import { NOVA_ROLE_PREFIX } from "../constants/roles";

/**
 * Maps user roles to translated display strings
 * Filters out non-Nova roles and translates the remaining ones
 */
export function mapUserRoles(rolesList: string[] | undefined): string {
  if (!rolesList) {
    return "";
  }

  const { $t } = useNuxtApp();

  // removing all the Roles not valid in NOVA
  const novaRoles = rolesList.filter((role) => role.startsWith(NOVA_ROLE_PREFIX));
  const translatedRoles = novaRoles.map((roleKey) => $t(`role-${roleKey}`));
  return translatedRoles.join(", ");
}
